<div class="container-box">
  <app-table-header tableTitle="Servizi pratiche" (btnUpdateClick)="loadServicePractices()">
    <app-button-new-service-practice action-button></app-button-new-service-practice>
  </app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="servicePracticesTable"
      class="table-content"
      [settings]="settings"
      [source]="source"
    ></ng2-smart-table>
  </div>
</div>
